import { jsx as _jsx } from "react/jsx-runtime";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { getSlateTypographyVariant } from "@faire/retailer-shared/SlateMappings/getSlateTypographyVariant";
import { Span } from "@faire/web--source/slate/Typography";
import React from "react";
import styled, { css } from "styled-components";
export var SlateText = function(param) {
    var textElement = param.textElement, isUnderlined = param.isUnderlined;
    var _textElement_style, _textElement_style1, _textElement_style2;
    if (!(textElement === null || textElement === void 0 ? void 0 : textElement.text)) {
        return null;
    }
    var variant = getSlateTypographyVariant(textElement === null || textElement === void 0 ? void 0 : (_textElement_style = textElement.style) === null || _textElement_style === void 0 ? void 0 : _textElement_style.type, textElement === null || textElement === void 0 ? void 0 : (_textElement_style1 = textElement.style) === null || _textElement_style1 === void 0 ? void 0 : _textElement_style1.decorators);
    var color = getSlateColorToken(textElement === null || textElement === void 0 ? void 0 : (_textElement_style2 = textElement.style) === null || _textElement_style2 === void 0 ? void 0 : _textElement_style2.color);
    return /*#__PURE__*/ _jsx(StyledSpan, {
        variant: variant,
        color: color,
        $isUnderlined: isUnderlined,
        children: textElement.text
    });
};
var StyledSpan = styled(Span).withConfig({
    componentId: "sc-ed5f10d6-0"
})([
    "text-decoration:",
    ";"
], function(param) {
    var $isUnderlined = param.$isUnderlined, color = param.color;
    return $isUnderlined ? css([
        "underline ",
        ""
    ], color) : "none";
});
